import styled, { css } from 'styled-components';
import { HeadingTravelTypeProps } from './TravelTypeHeading';

export const Element = styled.div<HeadingTravelTypeProps>`
  ${({ theme, ...props }) => {
    return css`
      //text-align: center;
      margin-bottom: ${theme.spacing.base};
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        margin-bottom: ${theme.spacing.md};
      }
      > {
        p:first-child {
          display: flex;
          align-items: center;
          //justify-content: center;
          gap: ${theme.spacing.sm};
        }
      }
    `;
  }};
`;
